import React from 'react';
import { defineMessages } from 'react-intl-next';

import PencilIcon from '@atlaskit/icon/core/edit';

import { useContentLastUpdated } from '../hooks/useContentLastUpdated';

import { PersonRow } from './PersonRow';

const i18n = defineMessages({
	lastUpdatedBy: {
		id: 'details-panel.properties-section.last-updated-row',
		defaultMessage: 'Last updated by',
		description:
			'A title that accompanies the avatar and name of the user who last updated this content',
	},
	accessibleAvatarLabel: {
		id: 'details-panel.properties-section.last-updated-row.accessible-avatar-label',
		defaultMessage: '{displayName}’s profile picture',
		description: "Alt text and aria-label for a user's profile picture",
	},
});

export const LastUpdatedRow = () => {
	const { data, error, refetch, loading } = useContentLastUpdated();

	return (
		<PersonRow
			loadingTestId="last-updated-row-loading"
			icon={<PencilIcon label="" />}
			analyticsRole="lastUpdater"
			i18n={{ accessibleAvatarLabel: i18n.accessibleAvatarLabel, personLabel: i18n.lastUpdatedBy }}
			data={data}
			error={error}
			refetch={refetch}
			loading={loading}
		/>
	);
};
